<template>
    <div class="container">
<div class="modal-dialog">
      
      <div class="modal-content">
          <div class="modal-header">
                <h2 class="modal-title text-center"><i class="fa fa-thumbs-o-up"></i> Reservation Completed </h2>
          </div>
            
          <div class="modal-body" >
              <div class="row">
                <div class="well">
                    <p>The sitter will be notified of your request and will review the details and answer you soon.</p>
                    <p>You can send another reservation to different sitter as well to ensure that at least one of them is available, go to Find Sitters if you want to contact another sitter.</p>
                </div>
                
              </div>


            <div class="">
              <button class="btn btn-info " @click="myReservations()">Go to Bookings</button>
              <button class="btn btn-info " @click="findSitters()">Find Sitters</button>
              <button class="btn btn-default pull-right" @click="goHome()">Go Home</button>
            </div>
              
               
              
              
          </div> <!-- end of body-->
      </div> <!-- end of modal content-->

  
  </div> <!--end of modal dialog-->
    </div>
</template>

<script>


export default {
    name: 'reservation-success', 
    data() {
        return {
         
        }
    },
    methods:{
        goHome: function(){
            this.$router.push({path: '/'})
        },
        findSitters: function(){
            this.$router.push({path: '/findsitters'})
        },
        myReservations: function(){
            this.$router.push({path: '/my-reservations'})
        },
        
    },
    mounted: function(){
       var self =this;
   
    },
    computed: {
    
    }
}

</script>


<style scoped>

</style>


// WEBPACK FOOTER //
// ReservationSuccess.vue?ff74a59a